// extracted by mini-css-extract-plugin
module.exports = {"root":"BuildBrand_root__y228Y","buildContainer":"BuildBrand_buildContainer__wXsiu"};